import { AfterViewInit, Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { AuctionEntity, AuctionFacade } from 'libs/gb-front/auction/data-access/src/'
import { AuctionApiService } from 'libs/gb-front/auction/data-access/src/lib/+state/auction-api.service'
import * as AuctionActions from 'libs/gb-front/auction/data-access/src/lib/+state/auction.actions'
import { GbAuctionHomeUrlService } from 'libs/gb-front/auction/util/src'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'

@UntilDestroy()
@Component({
  selector: 'gb-not-found',
  templateUrl: './gb-not-found.component.html',
  styleUrls: ['./gb-not-found.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GbNotFoundComponent implements AfterViewInit {
  appUrl!: string
  auction!: string
  notFoundLoaderId = 'not-found-loader'
  @ViewChild('urlNameElement') urlNameElement!: ElementRef
  constructor(
    private auctionApiService: AuctionApiService,
    private gbNotificationService: GbNotificationService,
    private router: Router,
    private auctionFacade: AuctionFacade,
    @Inject(APP_CONFIG) protected appConfig: any,
  ) {
    this.appUrl = `https://${this.appConfig.appUrl}/`
  }

  loading = false

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.urlNameElement.nativeElement.focus()
    }, 0)
  }

  onSubmit(): void {
    this.loading = true
    this.auctionApiService
      .getAuction(this.auction)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (auction) => this.loadAuction(auction),
        error: () => {
          this.showError()
        },
      })
  }

  loadAuction(auction: AuctionEntity): void {
    // this.auctionFacade.dispatch(AuctionActions.getAuctionSuccess({ auction }))
    // skip fragment will skip the auction init guard
    // as the auction is being set already to the state on the
    // getAuctionSuccess no need to resync and reinitalize again
    const extra = {
      fragment: 'skip',
    }
    const urlFragments = GbAuctionHomeUrlService.getAuctionHomepage(auction)

    // it could have used the AuctionActions.redirectHomepage
    // but we have to set the this.loading to false
    this.router
      .navigate(urlFragments, extra)
      .then(() => {
        this.auctionFacade.dispatch(AuctionActions.getAuctionSuccess({ auction }))
        // removing the skip fragment
        const newUrl = window.location.href.split('#')[0]
        // change the url without reload the page
        window.history.pushState('', '', newUrl)
      })
      .finally(() => (this.loading = false))
  }

  showError(): void {
    this.loading = false
    this.gbNotificationService.error('NOT_FOUND.AUCTION_NOT_FOUND_MESSAGE', 'NOT_FOUND.AUCTION_NOT_FOUND_OK')
  }
}
